module.exports = __webpack_public_path__ + "static/img/5.c8b63d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn1/5.jpg
// module id = eLkX
// module chunks = 0